import { FunctionComponent } from 'preact';
import cn from 'classnames';

import { usePlayerState } from '../../hooks/usePlayerState';

interface PromotionPictureProps {
  promoImageUrl: string;
}

export const PromotionPicture: FunctionComponent<PromotionPictureProps> = ({
  promoImageUrl,
}) => {
  const state = usePlayerState();

  const isPaused = state === 'paused';

  return (
    <div
      className={cn('vgp-promotion-picture', { paused: isPaused })}
      style={{ backgroundImage: `url(${promoImageUrl})` }}
    />
  );
};
